import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

const SectionHeading = ({ fields, params }) => {
  return (
    <div
      className={`vds-section-heading${params?.centered ? ' vds-section-heading--centred' : ''}`}
      data-testid={`${fields.testid?.value}-section`}
    >
      <div className="vds-section-heading__inner">
        <Text
          tag="h3"
          className="vds-section-heading__title"
          field={fields.title}
          data-testid={`${fields.testid?.value}-title`}
        />
        {fields.subtitle && (
          <Text
            tag="h4"
            className="vds-section-heading__subtitle"
            field={fields.subtitle}
            data-testid={`${fields.testid?.value}-subtitle`}
          />
        )}
        <RichText field={fields.content} data-testid={`${fields.testid?.value}-content`} />
      </div>
    </div>
  );
};

export default SectionHeading;
